import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "unchecked",
  "use": "unchecked-usage",
  "viewBox": "0 0 24 25",
  "content": "<symbol viewBox=\"0 0 24 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"unchecked\">\n<path d=\"M4 1.5H20V-0.5H4V1.5ZM23 4.5V20.5H25V4.5H23ZM20 23.5H4V25.5H20V23.5ZM1 20.5V4.5H-1V20.5H1ZM4 23.5C2.34315 23.5 1 22.1569 1 20.5H-1C-1 23.2614 1.23858 25.5 4 25.5V23.5ZM23 20.5C23 22.1569 21.6569 23.5 20 23.5V25.5C22.7614 25.5 25 23.2614 25 20.5H23ZM20 1.5C21.6569 1.5 23 2.84315 23 4.5H25C25 1.73858 22.7614 -0.5 20 -0.5V1.5ZM4 -0.5C1.23858 -0.5 -1 1.73858 -1 4.5H1C1 2.84315 2.34315 1.5 4 1.5V-0.5Z\" fill=\"#B0BEC5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/sharedComponents/Icon/images/unchecked.svg
// module id = TwQi
// module chunks = 13